import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];
const createInviteLink = async (resourceId, apiToken = null) => {
    console.log("CALLING SERVER with getinvitecodeforresource")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getinvitecodeforresource',
            'createinvitelink': true,
            'resourceid': resourceId,
            'apiToken': apiToken
          },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is { 'success': true, 'usageDataDictionary': usageDataDictionary }
            if (resp.data?.success && resp.data.invitecode) {
                //usageDataDictionary contains {totalviews: 0, totaledits: 0, totalusersviewed: 0, totalusersedited: 0, 
                // editpermission: boolean, readpermission: boolean, adminpermission: boolean, invitecode: string}
                return resp.data.invitecode;
            } else {
                console.log("FAILED RESPONSE from getinvitecodeforresource call")
                return null;
            }
        }
        console.log("NO RESPONSE from getinvitecodeforresource call");
    }).catch((error) => { console.log(error); });
};

export default createInviteLink;